import createLucideIcon from '../createLucideIcon';

const Plus = createLucideIcon('PlusIcon', [
  ['path', { d: 'M5 12h14', key: '1ays0h' }],
  ['path', { d: 'M12 5v14', key: 's699le' }],
]);

export default Plus;
